import { TRootState } from '@store/index';
import { useSelector } from 'react-redux';

const useAuthSelector = () => {
    return useSelector((state: TRootState) => state.auth);
};

export default useAuthSelector;
